import { ref, onMounted } from 'vue';

import { detectBrowserDevice } from '../utils/browserDevice';

export function useBrowserDetect() {
   const browserName = ref('');
   const isMobile = ref(false);
   const isIOS = ref(false);
   const isAndroid = ref(false);

   const detectBrowser = () => {
      const userAgent = navigator.userAgent;

      if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
         return 'Google Chrome';
      } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
         return 'Safari';
      } else if (userAgent.includes('Firefox')) {
         return 'Mozilla Firefox';
      } else if (userAgent.includes('Edg')) {
         return 'Microsoft Edge';
      } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
         return 'Opera';
      } else if (userAgent.includes('MSIE') || userAgent.includes('Trident')) {
         return 'Internet Explorer';
      } else {
         return 'Unknown browser';
      }
   };

   onMounted(() => {
      const device = detectBrowserDevice(navigator);
      browserName.value = detectBrowser();
      isMobile.value = device.isMobile;
      isIOS.value = device.isIOS;
      isAndroid.value = device.isAndroid;
   });

   return {
      browserName,
      isMobile,
      isIOS,
      isAndroid,
   };
}
